import React, { useEffect, useRef } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import scanCornersSrc from '@cover/updatestarten/facescan-corners.svg';
import scanCircleSrc from '@cover/updatestarten/facescan-circle.svg';
import boxTopSrc from '@cover/updatestarten/box-top-left.svg';
import boxBottomLeftSrc from '@cover/updatestarten/box-bottom-left.svg';
import boxBottomRightSrc from '@cover/updatestarten/box-bottom-right.svg';

const AnimatedLayer = styled.img`
	position: absolute;
	transform-origin: center center;
	opacity: 0;
`

const ScanCorners = styled(AnimatedLayer)`
	height: 10.3%;
	top: 29.1%;
	left: 48%;
`
const ScanCircle = styled(AnimatedLayer)`
	height: 10.4%;
	top: 29.1%;
	left: 48.5%;
`
const BoxTop = styled(AnimatedLayer)`
	height: 8%;
	top: 6.5%;
	left: 11.5%;
`
const BoxBottomRight = styled(AnimatedLayer)`
	height: 8%;
	top: 75.5%;
	right: 10%;
`
const BoxBottomLeft = styled(AnimatedLayer)`
	height: 8%;
	top: 81.2%;
	left: 12.8%;
`

const UpdateStarten = ({ play }) => {
	const scanCorners = useRef(false);
	const scanCircle = useRef(false);
	const boxTop = useRef(false);
	const boxBottomLeft = useRef(false);
	const boxBottomRight = useRef(false);

	useEffect(() => {

		const timeline1 = anime.timeline({
			autoplay: play,
			loop: true,
		});

		timeline1
		.add({
			targets: scanCorners.current,
			delay: 1000,
			scale: 5,
			opacity: 1,
			duration: 600,
			easing: 'easeInOutElastic(1, .6)'
		}, 0)
		.add({
			targets: scanCircle.current,
			keyframes: [
				{scale: 5, opacity: 1, duration: 600, easing: 'easeInOutElastic(1, .6)'},
				{rotate: 120, duration: 250, easing: 'linear'},
				{rotate: 0, duration: 250, easing: 'linear'},
			]
		}, '-=300')
		.add({
			targets: scanCorners.current,
			keyframes: [
				{scale: 4.9, duration: 100, easing: 'easeOutSine'},
				{scale: 5, opacity: 1, duration: 100, easing: 'easeOutSine'},
			]
		})
		.add({
			targets: boxTop.current,
			easing: 'easeInOutElastic(1, .6)',
			duration: 500,
			opacity: 1,
			scale: 1.7,
			delay: 200,
		})
		.add({
			targets: boxBottomLeft.current,
			easing: 'easeInOutElastic(1, .6)',
			duration: 500,
			opacity: 1,
			scale: 1.7
		}, '-=200')
		.add({
			targets: boxBottomRight.current,
			easing: 'easeInOutElastic(1, .6)',
			duration: 500,
			opacity: 1,
			scale: 1.6,
			endDelay: 2000,
		}, '-=200')
		.add({
			targets: [boxTop.current, boxBottomLeft.current, boxBottomRight.current],
			easing: 'easeInOutElastic(1, .6)',
			duration: 600,
			opacity: 0,
			scale: 1
		})
		.add({
			targets: [scanCorners.current, scanCircle.current],
			easing: 'easeInOutElastic(1, .6)',
			duration: 600,
			opacity: 0,
			scale: 1,
			endDelay: 1000
		}, '-=400')

	}, [play])
	return (
		<>
			<ScanCorners ref={scanCorners} src={scanCornersSrc} />
			<ScanCircle ref={scanCircle} src={scanCircleSrc} />
			<BoxTop ref={boxTop} src={boxTopSrc} />
			<BoxBottomLeft ref={boxBottomLeft} src={boxBottomLeftSrc} />
			<BoxBottomRight ref={boxBottomRight} src={boxBottomRightSrc} />
		</>
	)
};

export default UpdateStarten;